<template>
  <v-dialog v-model="dialogDone" persistent max-width="700">
    <v-card class="pa-3">
      <v-card-title class="headline my-2">
        <span
          class="font-weight-bold text-body-2 text-sm-h6 text-md-h5"
          v-html="
            $t('cap_ord_detail_paid_from', {
              value: orderDetail.customer.phone
            })
          "
        >
        </span>
      </v-card-title>
      <v-card-subtitle>
        <div class="text-body-2 text-md-body-1 grey--text">
          {{ $t('title_ord_detail_card') }}
        </div>
      </v-card-subtitle>
      <v-card-text class="mt-n7">
        <v-row no-gutters>
          <v-col cols="12" sm="6">
            <v-row
              v-if="orderDetail.delivery.mode.toLowerCase() !== 'pickup'"
              no-gutters
            >
              <v-col sm="7">
                <v-select
                  v-model="orderDetail.delivery.name"
                  :items="deliveryAgents"
                  menu-props="auto"
                  label="No Delivery Agent"
                  single-line
                  disabled
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-row>
                  <v-col align="end">
                    <div v-if="orderDetail.subTotal" class="caption">
                      {{ $t('cap_ord_detail_sub_total') }}:
                    </div>
                    <div v-if="orderDetail.vat" class="caption">
                      {{ $t('cap_txt_vad') }}:
                    </div>
                    <div class="primary--text font-weight-bold">
                      {{ $t('cap_ord_detail_total') }}:
                    </div>
                    <div
                      v-if="orderDetail.delivery.fee"
                      class="primary--text font-weight-bold"
                    >
                      {{ $t('cap_delivery_fee') }}:
                    </div>
                  </v-col>
                  <v-col>
                    <div v-if="orderDetail.subTotal">
                      $ {{ orderDetail.subTotal | numberFormat }}
                    </div>
                    <div v-if="orderDetail.vat">
                      $ {{ orderDetail.vat | numberFormat }}
                    </div>
                    <div class="font-weight-bold">
                      $ {{ orderDetail.total | numberFormat }}
                    </div>
                    <div
                      v-if="orderDetail.delivery.fee"
                      class="font-weight-bold"
                    >
                      $ {{ orderDetail.delivery.fee | numberFormat }}
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="10" align="center">
                <v-icon class="primary--text mr-2">mdi-cash-minus</v-icon>
                <span class="black--text"
                  >{{ orderDetail.payment.method }} ({{
                    orderDetail.delivery.mode | toTitleCase
                  }})</span
                >
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6">
            <v-row>
              <v-col sm="2">
                <v-divider vertical color="#888"></v-divider>
              </v-col>
              <v-col sm="10" class="ml-n8">
                <v-row align="center" class="mt-n3">
                  <v-col sm="3">
                    <v-icon large class="blue--text"
                      >mdi-facebook-messenger</v-icon
                    >
                  </v-col>
                  <v-col sm="9" class="ml-n3">
                    <span class="black--text">{{
                      orderDetail.customer.name
                    }}</span>
                  </v-col>
                </v-row>
                <v-row align="center" class="mt-n3">
                  <v-col sm="3">
                    <v-icon class="grey--text">mdi-phone</v-icon>
                  </v-col>
                  <v-col sm="9" class="ml-n3">
                    <span class="black--text">{{
                      orderDetail.customer.phone
                    }}</span>
                  </v-col>
                </v-row>
                <v-row
                  v-if="
                    orderDetail.customer.hasOwnProperty('location') &&
                    orderDetail.customer.location.hasOwnProperty('address') &&
                    orderDetail.customer.location.address
                  "
                  align="start"
                  class="mt-n3"
                >
                  <v-col sm="3">
                    <v-icon class="grey--text">mdi-map-marker</v-icon>
                  </v-col>
                  <v-col sm="9" class="ml-n3">
                    <span class="black--text">{{
                      orderDetail.customer.location.address
                    }}</span>
                    <v-col
                      v-if="
                        orderDetail.customer.hasOwnProperty('location') &&
                        orderDetail.customer.location.hasOwnProperty('cord') &&
                        orderDetail.delivery.mode == 'delivery'
                      "
                    >
                      <v-row>
                        <CassQRcode :document-id="documentId"></CassQRcode>
                        <CassMapping :document-id="documentId"></CassMapping>
                      </v-row>
                    </v-col>
                  </v-col>
                </v-row>
                <v-row align="center" class="mt-n3">
                  <v-col sm="3">
                    <v-icon class="grey--text">mdi-square-edit-outline</v-icon>
                  </v-col>
                  <v-col sm="9" class="ml-n3">
                    <span class="grey--text font-italic">{{
                      noteFormat(orderDetail.customer.note)
                    }}</span>
                  </v-col>
                </v-row>
                <v-row
                  v-if="
                    orderDetail.payment.method == 'Cash' &&
                    orderDetail.payment.hasOwnProperty('cash') &&
                    orderDetail.delivery.mode == 'delivery'
                  "
                  align="center"
                  class="mt-n3"
                >
                  <v-col sm="3">
                    <v-icon class="grey--text">mdi-cash-minus</v-icon>
                  </v-col>
                  <v-col sm="9" class="ml-n3">
                    <span class="grey--text font-italic">{{
                      noteFormat(orderDetail.payment.cash)
                    }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" text @click="cancel(documentId)">{{
          $t('btn_txt_cancel')
        }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          dark
          max-width="150"
          @click="confirm(documentId)"
          >{{ $t('btn_txt_paid') }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CassMapping from '@/components/dialogs/CassMapping'
import CassQRcode from '@/components/dialogs/CassQRcode'

export default {
  comments: {
    CassMapping,
    CassQRcode
  },
  filters: {
    numberFormat(data) {
      return (Math.round(data * 100) / 100).toFixed(2)
    },
    toTitleCase(str) {
      return str.charAt(0).toUpperCase() + str.substr(1).toLowerCase()
    }
  },
  props: {
    documentId: {
      type: String,
      default: 'EhE7o1faLNMEu0GOPevu'
    },
    dialogDone: {
      type: Boolean
    }
  },
  data() {
    return {}
  },
  computed: {
    orderDetail() {
      if (this.documentId) {
        return this.$store.getters['order/orderAfterFilter'].filter(
          (order) => order.documentId === this.documentId
        )[0]
      } else {
        return this.$store.state.order.sample[0]
      }
    },
    deliveryAgents() {
      return this.$store.state.deliveryAgent.deliveryAgents.map((agent) => {
        return agent.name
      })
    }
  },
  methods: {
    /**
     * @func
     * @desc Change the status of component to previous status.
     * Change from `done` to `processing` then close dialog.f
     * @param [id]
     */
    cancel(documentId) {
      const payload = { documentId, status: 'processing' }
      this.$store.dispatch('order/changeLocalStatus', payload)
      const value = { dialogProcess: false, dialogDone: false }
      this.$emit('changeDialog', value)
    },
    /**
     * @func
     * @desc close the doneDialog by call $event to parent `processCardList.vue`
     */
    confirm(documentId) {
      const payload = { documentId }
      this.$store.dispatch('order/closingOrder', payload)
      const value = { dialogProcess: false, dialogDone: false }
      this.$emit('changeDialog', value)
    },
    noteFormat(data) {
      return data || this.$t('cap_no_note')
    }
  }
}
</script>
